
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { getOrderFeeDetail } from "@/api/api-charge-service";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class PiOrderDetail extends Vue {
  @Prop()
  infoData!: objAny;

  private costTableList: objAny[] = [];
  private costTableColumns: objAny[] = [
    {
      title: i18n.t("commonTableName.slotFlag"),
      key: "slotFlagDesc",
      minWidth: 110
    },
    {
      title: i18n.t("commonTableName.chargeElect"),
      key: "electricity",
      minWidth: 80
    },
    {
      title: i18n.t("commonTableName.chargeAmount"),
      key: "electAmount",
      minWidth: 120
    },
    {
      title: i18n.t("commonTableName.serviceAmount"),
      key: "serviceAmount",
      minWidth: 120
    },
    {
      title: i18n.t("commonTableName.totalAmount"),
      key: "totalAmount",
      minWidth: 120
    }
  ];
  private slotFlagObj: objAny = {
    "1": i18n.t("commonTableName.jian"),
    "2": i18n.t("commonTableName.feng"),
    "3": i18n.t("commonTableName.ping"),
    "4": i18n.t("commonTableName.gu")
  };
  private handleFlagObj: objAny = {
    1: i18n.t("abnormalOrder.pileCharging"),
    2: i18n.t("abnormalOrder.sysCharging")
  };
  private pageType = "";

  async getOrderFeeDetailList(): Promise<void> {
    const ret = await getOrderFeeDetail({ orderNo: this.infoData.orderNo });

    if (ret.status == this["$config"].apiStatus) {
      if (ret.data && ret.data[0]) {
        this.costTableList = ret.data[0].standardElecFeeDetail || [];
      }
    }
  }

  created(): void {
    this.pageType = this["$common"].request("type");
    if (this.pageType != "offOrder") {
      this.getOrderFeeDetailList();
    }
  }
}
